export const FieldMapping = {
  acrids: 'testMetadata.crid',
  acid: 'testMetadata.cid',
  adslot: 'adSlot',
  osv: 'osv',
  country: 'testMetadata.country_code_3',
  adtype: 'testMetadata.ad_type',
  createdBy: 'user.userName',
};

export const PageSizes = [5, 10, 20, 50, 100];

export const DefaultPageSize = 10;
export const DefaultPage = 1;
export const ETCD_PROFILE = process.env.APP_ENV;

export const assetUrls = [
  { id: 'url', label: 'Primary Asset' },
  { id: 'secondary_image_url', label: 'Secondary Image Asset' },
  { id: 'secondary_video_url', label: 'Secondary Video Asset' },
  { id: 'clickable_video_url', label: 'Clickable Video Asset' },
];
